<script setup lang="ts">
const { t } = useI18n();

const year = new Date().getFullYear();
</script>

<template>
  <div class="copyright">
    <div class="copyright__inner">
      <div class="copyright__item _copyright">©{{ year }}. RESURSI</div>
      <div class="copyright__item">
        <a
          class="copyright__link"
          href="https://abro.uz"
          target="_blank"
          :aria-label="t('madeBy')"
        >
          {{ t('madeBy') }}
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="less">
.copyright {
  background-color: @color-athens-gray-dark;

  &__inner {
    .container-d();

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: @size-x6;
    padding-bottom: @size-x6;
  }

  &__item,
  &__link {
    font-size: 15px;
    line-height: 100%;
    font-weight: 400;
    color: @color-silver-chalice;

    &._copyright {
      font-size: 14px;
      text-transform: uppercase;
    }
  }

  &__link {
    .color-change-hover();
  }
}
</style>
